import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRssSquare = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6667 11.6667C16.0869 11.6667 20.3262 13.4226 23.4518 16.5482C26.5774 19.6738 28.3333 23.9131 28.3333 28.3333M11.6667 19.5614C12.8186 19.5614 13.9593 19.7883 15.0235 20.2291C16.0878 20.67 17.0548 21.3161 17.8694 22.1306C18.6839 22.9452 19.33 23.9122 19.7709 24.9765C20.2117 26.0407 20.4386 27.1814 20.4386 28.3333M12.0936 27.8947H12.1053M18.3333 35H21.6667C26.3338 35 28.6673 35 30.4499 34.0917C32.0179 33.2928 33.2928 32.0179 34.0917 30.4499C35 28.6673 35 26.3338 35 21.6667V18.3333C35 13.6662 35 11.3327 34.0917 9.55008C33.2928 7.98206 32.0179 6.70722 30.4499 5.90828C28.6673 5 26.3338 5 21.6667 5H18.3333C13.6662 5 11.3327 5 9.55008 5.90828C7.98206 6.70722 6.70722 7.98206 5.90828 9.55008C5 11.3327 5 13.6662 5 18.3333V21.6667C5 26.3338 5 28.6673 5.90828 30.4499C6.70722 32.0179 7.98206 33.2928 9.55008 34.0917C11.3327 35 13.6662 35 18.3333 35Z",
		stroke: "#A1A1AA",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgRssSquare);
export default ForwardRef;
